export * from './IconPriceLabelStroked';
